import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutOrderZones extends Layout {
	sourceZones: DataSource;
	tableOrderZones: Table;
}
